import _ from '../../utils/underscore';
import BaseComponent from '../../base/base_component';
import Model from './history_model';
import DOM from '../../utils/dom';
import {SYSTEM_EVENTS, USER_EVENTS} from '../../events/events';
import Event from '../../utils/event';
import Device from '../../utils/device';
import DateFormatter from '../../utils/date_formatter';
import Strings from '../../utils/strings';
import Directive from "../../core/directive";
import SessionTimerController from "../session_timer/session_timer_controller";
import {HISTORY_TYPE} from '../../services/history/history_const';
import {GermanyResponsibleGamingButtonPlacement} from "../../../../common/const/responsible-gaming";
import {CyClass} from "../../../../common/cy-classes";
import { imagePreloadWithDefault } from '../../../../common/utils/image-preload';

const HISTORY_VIEW = require('./view/history.html');
const DETAILS_VIEW = require('./view/details.html');
const LAST_DAYS_SELECTOR= '.cgp-history-from-last-days-select';
const DOM_OBJECTS_IDS = {
    HISTORY_TABLE: '.cgp-history-table-container',
    DETAILS_HISTORY: '.cgp-details-history',
    DETAILS_CONTAINER: '.cgp-details-history-game-container',
    DETAILS_HEADER_LEFT_SECTION: '.cgp-header-section-left',
    DETAILS_HEADER_NAME: '.cgp-header-game-name',
    DETAILS_HEADER_SESSION_TIME: '.cgp-details-session-time',
    DETAILS_HEADER_DATETIME: '.cgp-header-game-datetime',
    DETAILS_HEADER_CLOSE: '.cgp-themes-icons-x',
    NO_HISTORY_MESSAGE: '.cgp-no-history-message',
    HISTORY_LAST_PAGE: '.cgp-history-lastpage',
    HISTORY_TABLE_AREA: '.cgp-history-table-area',
    HISTORY_TRIGGER_INFINITE_SCROLL: '.cgp-history-table-area .cgp-history-trigger-element',
    RESPONSIBLE_GAME_ICONS: '.cgp-details-history-resp-game-icons',
    AGE_RESPONSIBLE_GAME: '.cgp-details-history-age-responsible-game'
};


const CATEGORY_NAME_DETAILED = 'Client_GamingHistory_Detailed';

class HistoryComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HistoryComponentController';

    DATETIME_FORMATTING = 'dd-mm-yyyy H:MM:ss';

    /**
     * take history from last days. default 30 days.
     * @type {number}
     */
    //TODO add listener to the user input that choose between 30/60/90 options.
    fromLastDays = 30;

    /**
     * Current history game entity.
     *
     * @type {null}
     * @private
     */
    _currentHistoryGame = null;


  /**
   * set as a parameter of the directive
   * when true More Details History button is displayed
   * @type {boolean}
   * @private
   */
  _showMoreDetails = true;
  /**
   * true as long as all the requests for building page are finalized
   * @type {boolean}
   * @private
   */
  _retrievingData = false;

  _currentLayoutGamesTypesPromise;
    /**
     *
     * @param params
     */
    init(params) {
        super.init();

       if (params && params.showMoreDetails !== undefined){
         this._showMoreDetails = _.toBoolean(params.showMoreDetails);
       }

        this._setHistoryType(params.historyType);
        this._setDateTimeFormat();

        this._setIsMobile();

        let languageService = this.serviceFactory.languageService();
        this._moreDetailsText = languageService.translation('history_more_details');
        this._moreDetailsNoDeviceAvailableText = languageService.translation('history_more_details_no_device_available_' + (this._isMobile ? 'mobile' : 'pc'));

        this._gameDefaultIcon = this.serviceFactory.gameService().getGameDefaultIcon();

        this._currentLayoutGamesTypesPromise = this.serviceFactory.integrationService().getAllGameTypes();

        this._setInitModel(params);

        this._setHTML();

        this._hideInfiniteScrollLoading();

        this._hideLastPageMessage();

        this._hideNoHistoryMessage();

        this._createFromLastDaysDropdown();
    }

    _createFromLastDaysDropdown() {
        let lastDaysSelect = this.getEl().querySelector(LAST_DAYS_SELECTOR);

        // Check if this element already exists - if not wait to him
        if(_.isNullOrUndefined(lastDaysSelect)) {
            setTimeout(() => {
                return this._createFromLastDaysDropdown();
            },10, this);

            return;
        }

        let lastDaysOptions = [30,60,90].map(optionItem => {
            let el = DOM.createElement('option');
            DOM.addClass(el, ['cgp-history-from-last-days-text', 'cgp-theme-property-color-base01']);
            el.value = optionItem;
            let languageService = this.serviceFactory.languageService();
            let translatedString = languageService.translation('history_last_days');
            if(translatedString) {
                el.text = new Strings(translatedString).injectIntoCurly({numberOfDays: optionItem});
            }

            return el;
        });

        lastDaysOptions.forEach(el => {
            DOM.append(lastDaysSelect, el);
        });

        lastDaysSelect.onchange = function() {
            this.fromLastDays = lastDaysSelect.value;

            // Send analytics when the last days select changed.
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: 'history_table_dropdown',
                action: 'ActionDropDown',
                label: this.fromLastDays
            });

            this._infiniteScroll && this._infiniteScroll.stop();

            this.start();
        }.bind(this);
    }

    /**
     * @public
     */
    start() {
        // Hide last page message.
        this._hideLastPageMessage();

        if (!this.serviceFactory.oAuth2Service().isAuthorized()) {
            this._resetModel();

            this._showNoHistoryMessage();

            this.logger.debug('User must be logged in to view the history');

            return null;
        }


        // Change width in PC according to client preferences.
        // if (!Device.isMobile()) {
        //     DOM.addClass(document.getElementsByClassName('cgp-directive-history')[0], 'cgp-theme-property-history-table-width-pc');
        // }

      this._nextPageNumber = 1;

      this
            ._clearTable()
            ._showInfiniteScrollLoading()
            ._setInfiniteScroll();
    }

    /**
     * Disable/enable the last days selector.
     * @private
     */
    _disableLastDaysSelector(status) {
        let lastDaysSelect = this.getEl().querySelector(LAST_DAYS_SELECTOR);

        lastDaysSelect ? lastDaysSelect.disabled = status : this.logger.debug('History do not have last days selector');
    }


    _setHistoryType(historyType) {
        this.historyType = _.safeStringToNumber(historyType, 1);
    }

    /**
     * Reset paging in order to get page 1 again
     * @private
     */
    _setDateTimeFormat() {
        this.DATETIME_FORMATTING = this.serviceFactory.skinService().getDateTimeHistoryFormat();

        return this;
    }

    _pages = [];
    _nextPageNumber = 1;

    get _noMorePages() {
        return this._nextPageNumber > this._pages.length;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _buildTable() {

        this._retrievingData = true;

        let requestParams = {
            fromLastDays: this.fromLastDays,
            pageNumber: this._nextPageNumber
            //pageSize: 3
        };

        if (this._nextPageNumber > 1) {
            const nextPageInfo = this._pages[this._nextPageNumber - 1];
            requestParams.requestKey = nextPageInfo.RequestKey;
            requestParams.minDate = nextPageInfo.MinDate;
            requestParams.maxDate = nextPageInfo.MaxDate;
        }

        return this.serviceFactory.historyService().getNextPage(this.historyType, requestParams)
            .then(data => {
                if (this._nextPageNumber === 1) {
                    this._pages = data.PagingData || [];
                } else {
                    data.PagingData = this._pages;
                }

                this._nextPageNumber++;
                return this._setModel(data);
            })
            .then(data => this._createTable(data))
            .then(() => {
                this._disableLastDaysSelector(false);
                return this._stopInfiniteScrollIfNoData();
            })

            .then(() => {
              this._showNoHistoryMessage();
              this._retrievingData = false;
            })

            .catch(err => {
                this._disableLastDaysSelector(false);

                this.logger.error('Could not get History => ', err);

                this._showNoHistoryMessage();
              this._retrievingData = false;
            });
    }

    /**
     * xxxxx
     *
     * @private
     */
    _setIsMobile() {
        this._isMobile = Device.isMobile();
    }


    /**
     * xxxxx
     *
     * @private
     */
    _setInfiniteScroll() {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_TRIGGER_INFINITE_SCROLL);

        this._infiniteScroll = this.serviceFactory.infiniteScrollService();
        this._infiniteScroll.initScrollMagic(el);
        this._infiniteScroll.onScroll(() => {
            // Stop the infite scroll until we got the history data.
            this._infiniteScroll.stop();
            this._disableLastDaysSelector(true);
            if (!this._retrievingData){
              return this._buildTable();
            }
        });

        this.logger.debug('Setting InfiniteScroll');

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _showInfiniteScrollLoading() {
        this._hideNoHistoryMessage();

        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_TRIGGER_INFINITE_SCROLL);

        DOM.show(el);

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _hideInfiniteScrollLoading() {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_TRIGGER_INFINITE_SCROLL);

        DOM.hide(el);

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _showLastPageMessage() {
        this._hideNoHistoryMessage();
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_LAST_PAGE);

        DOM.show(el);

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _hideLastPageMessage() {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_LAST_PAGE);

        DOM.hide(el);

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _stopInfiniteScrollIfNoData() {
        let historyData = this._model.getHistoryData();

        if (this._noMorePages) {
            this._hideInfiniteScrollLoading();

            if (historyData.GameHistoryData) {
                this._showLastPageMessage();
            }
        } else {
            // Set inifinite scroll when there is more pages.
            this._setInfiniteScroll();
        }

        return historyData;
    }

    /**
     * Set Model
     * @returns {AboutController}
     * @private
     */
    _setModel(data) {
        this._model = Model.create(data);

        return this._model.getPromiseModel();
    }

    /**
     * Set initial model
     * @param data
     * @private
     */
    _setInitModel(data) {
        this._model = Model.create(data);
    }

    /**
     * Set Model
     * @returns {AboutController}
     * @private
     */
    _resetModel() {
        this._setModel();
    }

    /**
     * Start the component view.
     *
     * @returns {AboutController}
     * @private
     */
    _setHTML() {
        let bakedHTML = this.bake(HISTORY_VIEW);
        this.setHTML(bakedHTML);

        return this;
    }

    /**
     * Wrapper to close component overlay
     *
     * @returns
     * @private
     */
    _close() {
        super.destroy();
    }

    /**
     * Create the table rows
     *
     *
     * @returns {AboutController}
     * @private
     */
    _createTable(historyData) {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_TABLE);

        this._hideNoHistoryMessage();

        this._createRows(el, historyData);

        return historyData;
    }

    /**
     * Create table rows
     *
     *
     * @returns
     * @private
     */
    _createRows(container, dataHistory) {
        return dataHistory && dataHistory.map(hist => {
                let li = this._getNewHistoryRow(hist);
                this._addHeader(li, hist);
                this._addBody(li, hist);
                DOM.append(container, li);

                return li;
            });
    }

    /**
     * xxxxx
     *
     * @private
     */
    _getNewHistoryRow(hist) {
        let li = DOM.createElement('li');
        DOM.addClass(li, 'cgp-provider-' + _.dasherize(hist.CompanyName));
        DOM.addClass(li, 'cgp-theme-property-background-color-darkmain');
        DOM.addClass(li, CyClass('cy-gaming-history-row'));

        return li;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _getNewRow(container, classList) {
        if (!classList) {
            classList = [];
        }
        classList.push('cgp-table-row');

        let row = this._getNewCell(null, classList);
        DOM.append(container, row);

        return row;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _addHeader(container, hist) {
        let //row = this._getNewRow(container, ['cgp-game-details-table-header', 'cgp-theme-property-border-bottom-color-base03']),
            headerData = this._getHeaderData(hist),
            numRows = headerData.length;

        for(let i = 0; i < numRows; i++) {
            let row = this._getNewRow(container, ['cgp-game-details-table-header', 'cgp-theme-property-border-bottom-color-base03'].concat(headerData[i].classList));
			for (let prop in headerData[i].data) {
				let cellData = headerData[i].data[prop];
				DOM.append(row, this._getNewCell(cellData.data, cellData.classList));
			}
		}
    }

    /**
     * Get header data according to regular and history type
     * @param hist
     * @returns {*}
     * @private
     */
    _getHeaderData(hist) {
        return this.historyType === HISTORY_TYPE.Regular  ?
            this.serviceFactory.regulationService().getHistoryHeaderRows(hist) :
            this.serviceFactory.regulationService().getGameSessionHistoryHeaderRows(hist)
    }

    /**
     * xxxxx
     *
     * @private
     */
    _addBody(container, hist) {
        let row = this._getNewRow(container, ['cgp-history-summarized-details']);

        // Create picture container
        let pictContainer = this._getNewCell(DOM.createElement('img', null, [CyClass('cy-gaming-history-game-image-dom')]), ['image']);
        let img = pictContainer.getElementsByTagName('img')[0];
        this._addPicture(img, hist);

        DOM.append(row, pictContainer);

        // Create date container and add content
        let secondSectionWrapper = this._getNewCell(null, ['cgp-section-second']);
        let dateWrapper = this._getNewCell(null, ['cgp-date-wrapper']);
        let dateContainer = this._getNewCell(null, ['cgp-date-container']);
        let dateIcon = this._getNewCell(null, ['cgp-themes-icons-history-calendar']);
        let dateText = this._getNewCell(null, ['cgp-game-date', CyClass('cy-gaming-history-play-date'), (Device.isMobile() ? 'cgp-themes-small-text' : 'cgp-themes-main-text')]);

        let clockService = this.serviceFactory.clockService();
        let historyDate = clockService.formatToRegulationOffset(hist.Date, hist.DateInTimeZone);
        let historySessionEndTimeDate = clockService.formatToRegulationOffset(hist.SessionEndDateTime);

        // if it's not local time, in order to prevent DateFormatter from create Date object in local time and
        // change it for the local date string, we have to pass isUTC flag to be true. This avoids changing the date
        dateText.innerHTML = this.historyType === HISTORY_TYPE.Regular ?
            DateFormatter.format(historyDate.date.toString(), this.DATETIME_FORMATTING, historyDate.isUTC) : DateFormatter.format(historySessionEndTimeDate.date.toString(), this.DATETIME_FORMATTING, historySessionEndTimeDate.isUTC);

        DOM.append(dateContainer, dateIcon);
        DOM.append(dateContainer, dateText);
        DOM.append(dateWrapper, dateContainer);
        DOM.append(secondSectionWrapper, dateWrapper);
        DOM.append(row, secondSectionWrapper);
        this._addBigWin(dateWrapper, hist);
        if (false === this._isMobile && this.historyType === HISTORY_TYPE.Regular) {
            this._addFreePlayIndications(dateWrapper, hist);
        }

        // Create Data_Container and add Content
        let dataContainer = this._getNewCell(null, ['cgp-table-col-mb', 'cgp-game-details-table']);
        this._addDataColumns(dataContainer, hist);
        DOM.append(row, dataContainer);
        if(this.historyType === HISTORY_TYPE.Regular) {
            if (this._isMobile) {
                let moreDetailsCell = this._getNewCell(null, []);
                let rowForMoreDetailsMobile = this._getNewRow(container, ['cgp-history-moreDetails-mobile']);
                this._addFreePlayIndications(rowForMoreDetailsMobile, hist);
                this._addMoreDetails(moreDetailsCell, hist).then(() => {
                    DOM.append(rowForMoreDetailsMobile, moreDetailsCell);
                });
            } else {
                this._addMoreDetails(dataContainer, hist);
            }
        }
    }

    _isFreePlayBet(hist) {
        let isFreePlayBet = !_.isNullOrUndefined(hist.FreePlayCurrentAmount);
        if (!isFreePlayBet) {
            isFreePlayBet = _.isNumber(hist.FreePlayWinningAmount);
        }
        return isFreePlayBet;
    }


    /**
     *
     *
     * @private
     */
    _addFreePlayIndications(container, hist) {
        let hisotryFreePlayNotifyWrapper = this._getNewCell(null, ['cgp-history-freePlay-notify-wrapper']);
        let langService = this.serviceFactory.languageService();

        let isFreePlayBet = this._isFreePlayBet(hist);

        if (isFreePlayBet) {
            if (hist.FreePlayReachedMaxWinCap === true) {
                DOM.append(hisotryFreePlayNotifyWrapper, this._getNewCell(langService.translation('hisotry_free_play_maxcup_indication'), ['cgp-themes-small-secondary-grayed-out-text', 'cgp-history-freePlay-maxCup-indication']));
            }
            DOM.append(hisotryFreePlayNotifyWrapper, this._getNewCell(langService.translation('hisotry_free_play_indication'), ['cgp-themes-small-secondary-grayed-out-text', 'cgp-history-freePlay-indication', 'cy-history-free-play-message']));
        }
        DOM.append(container, hisotryFreePlayNotifyWrapper);
    }

    /**
     * return if this game support detailed history
     * @param hist
     * @returns {*}
     * @private
     */
    _isSupportDetailedHistory(hist) {
        // If we don't have this property - default is true.
        if (!hist || (typeof hist.IsSupportDetailedHistory !== 'boolean')) {
            return true;
        }

        return this._showMoreDetails && hist && hist.IsSupportDetailedHistory;
    }



    /**
     * xxxxx
     *
     * @private
     */
    _addMoreDetails(container, hist) {
        return this.serviceFactory.companySelectorService().getCompany(hist.CompanyName).then(company => {

            if (!company.supportsHistoryMoreDetails(hist)) {
                return;
            }

            if (!this._isSupportDetailedHistory(hist)) {
                return;
            }
            let moreDetails = this._getNewCell(null , ['cy-history-more-details','cgp-game-body-more-details', 'cgp-theme-property-background-color-base05']);
            this._addLinkToHistoryDetails(hist, moreDetails);

            this._addCellValue(moreDetails, null, ['cgp-themes-icons-details-left-corner', 'cgp-theme-property-background-color-darkmain']);
            this._addCellValue(moreDetails, this._getGotoDetails(hist), ['cgp-game-more-details-link']);

            let historyRightArrowIconWrapper = this._getNewCell(null, ['history-right-arrow-icon-wrapper']);
            let historyRightArrowIcon = this._getNewCell(null, ['cgp-themes-icons-right-arrow', 'cgp-history-icons-right-arrow']);
            DOM.append(historyRightArrowIconWrapper, historyRightArrowIcon);
            DOM.append(moreDetails, historyRightArrowIconWrapper);
            DOM.append(container, moreDetails);
        });
    }

    _addBigWin(container, hist) {
        if (!hist.IsBigWin) {
            return;
        }
        let languageService = this.serviceFactory.languageService();
        let historyBigWinTaxMessageString = languageService.translation('history_big_win_tax_message');
        let historyBigWinTaxMessage = this._getNewCell(historyBigWinTaxMessageString, ['cgp-game-body-big-win', CyClass('cy-gaming-history-big-win-message')]);
        DOM.append(container, historyBigWinTaxMessage);
    }
    /**
     * xxxxx
     *
     * @private
     */
    _addPicture(imgEl, hist) {

        const images = this._getPropInGameSession(hist, 'images');
        const imageIcon = _.isObject(images) && images.icon ? this._getResolvedGameImagePath(images.icon) : '';
        const gameTypeId = hist.GameTypeId;

        imagePreloadWithDefault(imageIcon, this._gameDefaultIcon).then(iconLoaded => {
            if (iconLoaded.error) {
                this.logger.error(iconLoaded.error);
            }
            imgEl.src = iconLoaded.backgroundUrl;
            return this;
        });

        this._currentLayoutGamesTypesPromise.then(currentLayoutGamesTypes => {
            if(currentLayoutGamesTypes.includes(Number(gameTypeId))){

                DOM.addClass(imgEl, 'clickable');

                this.onDOMEvent(imgEl, USER_EVENTS.ON_CLICK,  () => {
                    this.serviceFactory.gameService().openRealGame({gameType: gameTypeId});
                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                        category: 'Client_GamingHistory',
                        action: 'open_game',
                        label: this._getGameLabel(gameTypeId, this._getPropInGameSession(hist, "title")),
                        value: gameTypeId
                    });
                });
            }
        });
    }

    _getResolvedGameImagePath(imageFile) {
        return this.serviceFactory.gameService().resolveGameImagePath(imageFile);
    }

    /**
     * xxxxx
     *
     * @private
     */
    _addDataColumns(container, hist) {
        let row = this._getNewRow(container, ['cgp-game-details']);
        let dataContainer = this._getNewCell(null, ['cgp-table-col-mb', 'cgp-data-columns']);

        DOM.append(row, dataContainer);

        this._addDetails(dataContainer, hist);
    }




    /**
     * Add history result details.
     *
     * @param container
     * @param hist
     * @private
     */
    _addDetails(container, hist) {
        let langService = this.serviceFactory.languageService();
        let currencyService = this.serviceFactory.currencyService();

        this.historyType === HISTORY_TYPE.Regular ? this._addDetailsRegularHistory(container, hist, langService, currencyService) : this._addDetailsGameSessionHistory(container, hist, langService, currencyService);
    }

    /**
     * Add data for regular history
     * @param container
     * @param hist
     * @param langService
     * @param currencyService
     * @private
     */
    _addDetailsRegularHistory(container, hist, langService, currencyService) {

        const isFreePlayBet = this._isFreePlayBet(hist);
        let historyWinningsKey = _.isNullOrUndefined(hist.OriginalWinningsAmount) ? 'history_winnings' : 'history_winnings_bonus_cap';

        this._addCellTitleValue(this._getNewRow(container), isFreePlayBet ? langService.translation('hisotry_free_play_bet') : langService.translation('history_bet'), currencyService.formatMoney(hist.BetAmount), [CyClass('cy-gaming-history-bet-value')]);
        this._addCellTitleValue(this._getNewRow(container), isFreePlayBet ? langService.translation('hisotry_free_play_winnings') : langService.translation(historyWinningsKey), currencyService.formatMoney(hist.ProfitAmount), [CyClass('cy-gaming-history-winning-value')]);

        if (isFreePlayBet) {
            this._addCellTitleValue(this._getNewRow(container), langService.translation('hisotry_free_play_reward_winnings'), currencyService.formatMoney(hist.FreePlayWinningAmount));

            if (!_.isNullOrUndefined(hist.FreePlayCurrentAmount)) {
                this._addCellTitleValue(this._getNewRow(container), langService.translation('hisotry_free_play_reward_bankroll'), currencyService.formatMoney(hist.FreePlayCurrentAmount));
            }
        } else {
            this._addCellTitleValue(this._getNewRow(container), langService.translation('history_bankroll'), currencyService.formatMoney(hist.AvailableMoneyPerOffering), [CyClass('cy-gaming-history-bankroll-value')]);
        }
    }

    /**
     * Add data for game session history
     * @param container
     * @param hist
     * @param langService
     * @param currencyService
     * @private
     */
    _addDetailsGameSessionHistory(container, hist, langService, currencyService) {
        this._addCellTitleValue(this._getNewRow(container), langService.translation('hisotry_game_session_total_bets'), currencyService.formatMoney(hist.TotalBets));
        this._addCellTitleValue(this._getNewRow(container), langService.translation('hisotry_game_session_total_winnings'), currencyService.formatMoney(hist.TotalWins));
        this._addCellTitleValue(this._getNewRow(container), langService.translation('hisotry_game_session_balance'), currencyService.formatMoney(hist.SessionBalance));
    }

    /**
     * xxxxx
     *
     * @private
     */
    _addCellValue(container, content, classList) {
        DOM.append(container, this._getNewCell(content, ['cgp-table-col-mb'].concat(classList)));
    }

    /**
     * xxxxx
     *
     * @private
     */
    _addCellTitleValue(container, title, content, valueClassList = []) {
        let textStyles = this._isMobile ? ['cgp-themes-small-text', 'cgp-theme-property-color-base01'] : ['cgp-themes-main-text'];

        DOM.append(container, this._getNewCell(title, ['cgp-table-col-mb', 'cgp-history-table-name'].concat(textStyles)));
        DOM.append(container, this._getNewCell(content, ['cgp-table-col-mb', 'cgp-history-table-value', ...valueClassList].concat(textStyles)));
    }

    /**
     * xxxxx
     *
     * @private
     */
    _getGotoDetails(hist) {
        let isHistoryDetailsEnable = this._isHistoryDetailsEnable(hist.AllowedPlatformType);
        let html = '';
        let moreDetailsClasses = ['cgp-to-details'];

        if (Device.isMobile()) {
            moreDetailsClasses.push('cgp-themes-small-text');
        } else {
            moreDetailsClasses.push('cgp-themes-main-text');
        }

        if (isHistoryDetailsEnable) {
            html = this._getNewCell(this._moreDetailsText + ' <span></span>', moreDetailsClasses);
        } else {
            html = this._getNewCell(this._moreDetailsNoDeviceAvailableText, moreDetailsClasses);
        }

        return html;
    }

    _addLinkToHistoryDetails(hist, elem) {
        let isHistoryDetailsEnable = this._isHistoryDetailsEnable(hist.AllowedPlatformType);

        if (isHistoryDetailsEnable) {
            this.onDOMEvent(elem, USER_EVENTS.ON_CLICK, () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: 'Client_GamingHistory',
                    action: 'MoreDetails',
                    label: this._getGameLabel(hist.GameTypeId, this._getPropInGameSession(hist, "title"))
                });

                this._showHistoryGame(hist);
            });
        } else {
            elem.className += ' no-device-available';
        }
    }

    /**
     *
     * @param gameId
     * @param gameName
     * @returns {string}
     * @private
     */
    _getGameLabel(gameId, gameName = '') {
        if (!gameName) {
            return gameId;
        }

        return gameId + '_' + gameName.replace(/ /g, '');
    }

    /**
     * xxxxx
     *
     * @private
     */
    _getNewCell(content, classList) {
        let col = DOM.createElement('div');

        if (_.isString(content)) {
            col.innerHTML = content;
        } else if (_.isHTMLDivElement(content) || _.isHTMLImgElement(content)) {
            DOM.append(col, content);
        }

        classList.forEach && classList.forEach(className => DOM.addClass(col, className));

        return col;
    }


    /**
     * Patch. Open NetEnt game in new tab
     * @param data
     * @returns {Promise<U>|*|Promise.<TResult>}
     * @private
     */
    _openGameInNewTab(data) {
        let windowCurrentExecutionEventClick = window.open('about:blank', '_blank');
        let gnwpParams = {
            gameType: data.GameTypeId,
            gameId: data.GameId,
            isMobile: false,
            templateName: data.CompanyName,
            isReal: true,
            isHistory: true
        };
        return this.serviceFactory.gnwpService().getGNWPResponse(gnwpParams)
            .then((response) => {
                let url = response.getGNWPUrl();
                if (windowCurrentExecutionEventClick) {
                    windowCurrentExecutionEventClick.location = url;
                }
            });
    }

    /**
     * check if we can open the game in second Web View
     *
     * @private
     */
    _isHybridSecondWebView(){
        return Device.isHybrid() && this.serviceFactory.hybridService().isNativeSupportSecondWebView();
    }


    /**
     * xxxxx
     *
     * @private
     */
    _showHistoryGame(gameHistory) {
        this.serviceFactory.gameService().openHistoryGame({
            gameType: gameHistory.GameTypeId,
            gameRoundId: gameHistory.GameId,
            gameRoundDate: gameHistory.Date
        }).then(gameOptions => {
            if(gameOptions.gameBody) {
                this._currentHistoryGame = gameOptions.gameBody;

                this._showDetails(gameHistory, gameOptions.gameBody.getEl());

                this._currentHistoryGame.onAppendedToDOM();
            }
        });
    }


    _clearTable() {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.HISTORY_TABLE);

        // Clear previous directive DOM html.
        el.innerHTML = '';

        return this;
    }

    /**
     * xxxxx
     *
     * @private
     */
    _showNoHistoryMessage() {
        if (!this._model || !this._model.getPaging() || this._model.getPaging().length === 0) {
            this._clearTable();
            this._hideInfiniteScrollLoading();
            this._hideLastPageMessage();

            const el = this.getEl().querySelector(DOM_OBJECTS_IDS.NO_HISTORY_MESSAGE);

            DOM.show(el);
        }
    }

    /**
     * xxxxx
     *
     * @private
     */
    _hideNoHistoryMessage() {
        const el = this.getEl().querySelector(DOM_OBJECTS_IDS.NO_HISTORY_MESSAGE);

        DOM.hide(el);
    }

    /**
     * xxxxx
     *
     * @private
     */
    _showDetails(historyLoaded, historyDetailsEL) {
        const container = DOM.createElement('div', DETAILS_VIEW);
        const analytics_label = this._getGameLabel(historyLoaded.GameTypeId, this._getPropInGameSession(historyLoaded, "title"));

        // Set Background if mobile
        if (!this._isMobile) {
            container.querySelector(DOM_OBJECTS_IDS.DETAILS_HISTORY).style.backgroundImage = 'url(' + this._getPropInGameSession(historyLoaded, "background") + ')';
        }

        // Inject the Game Header
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_NAME).innerHTML = this._getPropInGameSession(historyLoaded, "title") || 'History Game';

        let historyDate = this.serviceFactory.clockService().formatToRegulationOffset(historyLoaded.Date, historyLoaded.DateInTimeZone);

        // Inject the Game DateTime
        // if it's not local time, in order to prevent DateFormatter from create Date object in local time and
        // change it for the local date string, we have to pass isUTC flag to be true. This avoids changing the date
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_DATETIME).innerHTML = DateFormatter.format(historyDate.date.toString(), this.DATETIME_FORMATTING, historyDate.isUTC);

        // Inject the Game itself
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_CONTAINER).appendChild(historyDetailsEL);

        this._injectAgeResponsibleGame(container);
        this._injectResponsibleGameIcons(container);

        this._injectSessionTimer(container);



        // Bind Close Button
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_CLOSE), USER_EVENTS.ON_CLICK, () => {
            //The reason we do it like this is because also Orbit wants to close the detail history window when the route changes (user press the back button in the browser)
            //and we want to share the close logic between SDK and Orbit
            this.serviceFactory.gameService().closeCurrentDetailHistory();
        });

        this._analyticsBind(container, analytics_label);

        //Open Overlay
        this._openDetailsGameOverlay(container, analytics_label);

        this.serviceFactory.gameService().attachDetailHistoryCloseHandler(this._closeDetails.bind(this));
    }


    _injectSessionTimer(container) {
        if (!this.serviceFactory.regulationService().sessionTimerVisible()) {
            return;
        }

        let sessionTimer = SessionTimerController.create();
		sessionTimer.start();
		this.innerComponentsRef.push(sessionTimer);
        container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_SESSION_TIME).appendChild(sessionTimer.getEl());
    }

    _injectAgeResponsibleGame(container) {
        if (!this.serviceFactory.regulationService().getRegulation().showAgeResponsibleGameInDetailedHistory()) {
            return;
        }

        let ageResponsibleGame = Directive.generate({directiveName: 'age_responsible_game', start: true, props: {}});
        container.querySelector(DOM_OBJECTS_IDS.AGE_RESPONSIBLE_GAME).appendChild(ageResponsibleGame.getEl())
    }

    _injectResponsibleGameIcons(container) {
        if (!this.serviceFactory.regulationService().getRegulation().showResponsibleIcons()) {
            return;
        }

        let responsibleIcons = Directive.generate({directiveName: 'responsible_gaming_icons', start: true, props: {placement:GermanyResponsibleGamingButtonPlacement.inDetailedHistory}});
        //DOM.addClass(responsibleIcons.getEl(), 'cgp-theme-property-background-color-dark-grey');
        container.querySelector(DOM_OBJECTS_IDS.RESPONSIBLE_GAME_ICONS).appendChild(responsibleIcons.getEl())
    }

    /**
     * xxxxx
     *
     * @param container, label
     * @private
     */
    _openDetailsGameOverlay(container, analytics_label) {
        window.CGP.openOverlay({
            el: container,
            level: 2,
            isCloseBtnAllowed: false,
            additionalClasses: ['cgp-overlay-history-details'],
            closeCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: CATEGORY_NAME_DETAILED,
                    action: 'Close',
                    label: analytics_label
                });
            },
            openCallback: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                    category: CATEGORY_NAME_DETAILED,
                    action: 'Open',
                    label: analytics_label
                });
            }
        });
    }

    /**
     * xxxxx
     *
     * @param container, label
     * @private
     */
    _analyticsBind(container, label) {
        // Bind Close Overlay
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_CLOSE), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: CATEGORY_NAME_DETAILED,
                action: 'CloseClick',
                label: label
            });
        });

        // Bind click header elements
        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_NAME), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: CATEGORY_NAME_DETAILED,
                action: 'GameName',
                label: label
            });
        });

        this.onDOMEvent(container.querySelector(DOM_OBJECTS_IDS.DETAILS_HEADER_DATETIME), USER_EVENTS.ON_CLICK, () => {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                category: CATEGORY_NAME_DETAILED,
                action: 'Time',
                label: label
            });
        });
    }

    /**
     * xxxxx
     *
     * @private
     */
    _closeDetails() {
        // Check if the history contain game history game entity instance.
        if (this._currentHistoryGame) {
            // Call game close to clean all events.
            this._currentHistoryGame.shutDown();
            // Clear the instance from the history component and look for the new one in the next open history game.
            this._currentHistoryGame = null;
            window.CGP.closeLastOverlay();
        }
    }

    /**
     * xxxxx
     *
     * @private
     */
    _getPropInGameSession(hist, prop) {
        return hist && hist.gameSession && hist.gameSession[prop];
    }

    /**
     * check if history details enable according to allowed platform type.
     * @param AllowedPlatformType
     * @returns {boolean}
     * @private
     */
    _isHistoryDetailsEnable(AllowedPlatformType) {
        let isHistoryDetailedEnable = false;

        switch(AllowedPlatformType && AllowedPlatformType.toLowerCase()) {
            case 'all':
                isHistoryDetailedEnable = true;
                break;
            case 'mobile':
                isHistoryDetailedEnable = this._isMobile ? true : false;
                break;
            case 'pc':
                isHistoryDetailedEnable = this._isMobile ? false : true;
                break;
            default:
                // maybe should throw an Exception here
                break;
        }

        return isHistoryDetailedEnable;
    }


    /**
     * Filter open session based the product packages.
     *
     * @private
     * @returns {Array}
     */
    _setInfiniteScrollTrigger(data) {
        let triggerEl = data[(data.length / 2).toFixed(0)];

        this._infiniteScroll.updateTriggerElement(triggerEl);
    }
}


export default HistoryComponentController;